/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthCreationContext } from './PalReauthCreationContext';
import {
    PalReauthCreationContextFromJSON,
    PalReauthCreationContextFromJSONTyped,
    PalReauthCreationContextToJSON,
    PalReauthCreationContextToJSONTyped,
} from './PalReauthCreationContext';

/**
 * 
 * @export
 * @interface GetPalReauthCreationContext200Response
 */
export interface GetPalReauthCreationContext200Response {
    /**
     * 
     */
    data?: PalReauthCreationContext;
}

/**
 * Check if a given object implements the GetPalReauthCreationContext200Response interface.
 */
export function instanceOfGetPalReauthCreationContext200Response(value: object): value is GetPalReauthCreationContext200Response {
    return true;
}

export function GetPalReauthCreationContext200ResponseFromJSON(json: any): GetPalReauthCreationContext200Response {
    return GetPalReauthCreationContext200ResponseFromJSONTyped(json, false);
}

export function GetPalReauthCreationContext200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalReauthCreationContext200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthCreationContextFromJSON(json['data']),
    };
}

export function GetPalReauthCreationContext200ResponseToJSON(json: any): GetPalReauthCreationContext200Response {
    return GetPalReauthCreationContext200ResponseToJSONTyped(json, false);
}

export function GetPalReauthCreationContext200ResponseToJSONTyped(value?: GetPalReauthCreationContext200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthCreationContextToJSON(value['data']),
    };
}

